module.exports = __webpack_public_path__ + "img/split.d3b29091.svg";